import type { EditableCreateFieldOptions } from '@cims-online/shared'
import CIMSTextArea from 'components/CIMSTextArea'
import type { CreationFieldProps } from '..'
import CreationFormItem from './CreationFormItem'

type LongTextCreationFieldProps = Omit<CreationFieldProps, 'field'> & {
  field: Extract<EditableCreateFieldOptions, { type: 'long_text' }>
}

/** Renders a long-text creation input with its resolved input behavior. */
function LongTextCreationField({
  error,
  field,
  onBlur,
}: LongTextCreationFieldProps) {
  return (
    <CreationFormItem
      control={
        <CIMSTextArea disabled={field.readOnly !== null} onBlur={onBlur} />
      }
      error={error}
      field={field}
    />
  )
}

export default LongTextCreationField
